import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { GeodeticAndCartographicServiceDataRequestRoutingModule } from './geodetic-and-cartographic-service-data-request-routing.module';
import { GACSDRNewRequestComponent } from './new-request/new-request.component';
import { GACSDRNewRequestFormService } from './services/new-request-form/new-request-form.service';
import { WorkPurposeDictionaryService } from './services/work-purpose-dictionary/work-purpose-dictionary.service';

@NgModule({
  declarations: [GACSDRNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    GeodeticAndCartographicServiceDataRequestRoutingModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  providers: [GACSDRNewRequestFormService, WorkPurposeDictionaryService],
})
export class GeodeticAndCartographicServiceDataRequestModule {}
